import { Col, Row } from "react-bootstrap";
import { formatMoney } from "../../../lib/format-money";
import React from "react";
import "./payment_confirmation.scss";
import { CreditCardPaymentMethod, InvoicingPaymentMethod } from "../../../constants/campaigns";

const PaymentConfirmation = props => {
  const {
    title,
    last4,
    brand,
    amount,
    chargeTypeText,
    additionalInfo,
    paymentMethodType = CreditCardPaymentMethod,
  } = props;

  let payment = (
    <>
      <div className="brand">{brand}</div>
      <div className="last4">{last4}</div>
    </>
  );
  if (paymentMethodType === InvoicingPaymentMethod) {
    payment = <div className="brand">Invoice</div>;
  }

  return (
    <>
      <Row>
        <div className={"page-3-container"}>
          <Col xs={10} xsOffset={1}>
            <h3 className={"title-left"}>{title || "Review your purchase"}</h3>
          </Col>
          <Col xs={10} xsOffset={1}>
            <div className="table">
              <div className="table-row flex-row-container">
                <div className={"left-column"}>Payment</div>
                <div className="spacer flex-1" />
                <div className={"right-column bold"}>{payment}</div>
              </div>
              <div className="table-row flex-row-container">
                <div className={"left-column"}>{chargeTypeText}</div>
                <div className="spacer flex-1" />
                <div className={"right-column amount bold"}>{formatMoney(amount)}</div>
              </div>
            </div>
            {additionalInfo ?? null}
          </Col>
        </div>
      </Row>
    </>
  );
};

export default PaymentConfirmation;
